var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.659668,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#1c3988"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 13.9927L16.4999 17.8677C17.3888 18.5343 18.611 18.5343 19.4999 17.8677L24.6666 13.9927",
    stroke: "#1c3988",
    strokeWidth: 1.6625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8333 12.3267H12.1667C11.2462 12.3267 10.5 13.0729 10.5 13.9933V22.3267C10.5 23.2471 11.2462 23.9933 12.1667 23.9933H23.8333C24.7538 23.9933 25.5 23.2471 25.5 22.3267V13.9933C25.5 13.0729 24.7538 12.3267 23.8333 12.3267Z",
    stroke: "#1c3988",
    strokeWidth: 1.6625,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.08d88523bbd5137076b6ef46d588b3d1.svg";
export { ForwardRef as ReactComponent };